import React, { useEffect, useState } from 'react';

import { useDispatch } from '@tmapy/redux';

import { Select, SelectProps } from '@tmapy/style-guide';

import { setAttachmentType } from '../actions/docDetail';

type AttachmentTypeSelectProps = {
  defaultValue: string;
  url: string;
  isDisabled: boolean;
  items: SelectProps['items'];
};

export const AttachmentTypeSelect: React.FC<AttachmentTypeSelectProps> = ({
  defaultValue,
  url,
  isDisabled,
  items,
}) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setValue(value);
    dispatch(setAttachmentType(name, value));
  };

  return (
    <Select
      value={value}
      name={url}
      isDisabled={isDisabled}
      items={items}
      onChange={handleChange}
    />
  );
};
